import { cn } from '@plato/ui/util/classes';
import { CurrencyOrEmpty } from '../../../components/typography/currency-or-empty.tsx';

type MoneyDeltaBadgeProps = {
    children: number | undefined | null;
};

export function MoneyDeltaBadge({ children }: MoneyDeltaBadgeProps) {
    const isPositive = children && children > 0 ? true : children && children < 0 ? false : null;

    return (
        <div
            className={cn(
                'flex shrink-0 flex-row items-center justify-center rounded-md font-bold',
                isPositive === true && ' text-green-600',
                isPositive === false && ' text-red-600',
                isPositive === null && ' text-neutral-600',
            )}
        >
            <CurrencyOrEmpty showPlusSignIfPositive>{children}</CurrencyOrEmpty>
        </div>
    );
}
